/**
 * Canonical PlatformPersonas definition.
 *
 * NOTE: This is the authoritative enum for all personas ("account types/personas").
 * Files such as apps/console/src/console/_statics/persona.statics.ts are DEPRECATED
 * and should not be imported; all persona logic and references should use this enum.
 *
 * Update this file for any new personas.
 */
export enum PlatformPersonas {
  CARRIER = 'CARRIER',
  DIGITAL = 'DIGITAL',
  COWBELL = 'COWBELL',
  CUSTOMER = 'CUSTOMER',
  VENDOR = 'VENDOR',
  CLUSTER = 'CLUSTER',
  AGENCY = 'AGENCY',
  MSSP = 'MSSP',
  POOL = 'POOL',
  RE_INSURER = 'RE_INSURER',
  PREMIUM_PROCESSOR = 'PREMIUM_PROCESSOR',
  FRANCHISE = 'FRANCHISE',
  UNKNOWN = 'UNKNOWN',
}

/** Backward-compatible alias — prefer PlatformPersonas for new code. */
export const PERSONA_TYPES = PlatformPersonas;
export type Persona = `${PlatformPersonas}`;
